// src/store/modules/config.js
import axios from "axios"; // 直接导入 axios

const state = {
  configData: {
    company: {
      company_address: "",
      company_address_en: "",
      company_phone: "",
      company_name: "",
      company_email: "",
      company_introduced: "",
      company_introduced_en: "",
    }, // 默认值
    service: null,
  },
};

const mutations = {
  SET_CONFIG_DATA(state, data) {
    state.configData = data;
  },
};

const actions = {
  fetchConfigData({ commit }) {
    return new Promise((resolve, reject) => {
      // 直接使用 axios 发送请求
      axios
        .get("/get_config")
        .then((res) => {
          const data = res.data.data;
          console.log("真实键列表：", Object.keys(data.company));
          console.log(data.company.company_address_en);

          console.log(data, "llll");
          commit("SET_CONFIG_DATA", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
